/**
 * Image Carousel Component
 *
 * Auto-sliding image carousel with fade transitions and pause/play controls.
 *
 * Usage in Liquid:
 * <div x-data="imageCarousel"
 *      data-autoplay-interval="{{ section.settings.autoplay_interval | default: 4000 }}"
 *      data-slide-count="{{ section.blocks.size }}">
 */

export default function imageCarousel() {
  return {
    autoplayIntervalTime: 4000,
    currentSlideIndex: 1,
    slideCount: 0,
    isPaused: false,
    autoplayInterval: null,

    init() {
      // Read configuration from data attributes
      const el = this.$el;
      this.autoplayIntervalTime = parseInt(el.dataset.autoplayInterval) || 4000;
      this.slideCount = parseInt(el.dataset.slideCount) || 1;

      // Start autoplay if there are multiple slides
      if (this.slideCount > 1) {
        this.autoplay();
      }
    },

    previous() {
      if (this.currentSlideIndex > 1) {
        this.currentSlideIndex = this.currentSlideIndex - 1;
      } else {
        // If it's the first slide, go to the last slide
        this.currentSlideIndex = this.slideCount;
      }
      this.resetAutoplay();
    },

    next() {
      if (this.currentSlideIndex < this.slideCount) {
        this.currentSlideIndex = this.currentSlideIndex + 1;
      } else {
        // If it's the last slide, go to the first slide
        this.currentSlideIndex = 1;
      }
      this.resetAutoplay();
    },

    goToSlide(index) {
      this.currentSlideIndex = index;
      this.resetAutoplay();
    },

    autoplay() {
      if (this.slideCount <= 1) return;

      this.autoplayInterval = setInterval(() => {
        if (!this.isPaused) {
          this.next();
        }
      }, this.autoplayIntervalTime);
    },

    resetAutoplay() {
      clearInterval(this.autoplayInterval);
      if (!this.isPaused && this.slideCount > 1) {
        this.autoplay();
      }
    },

    togglePause() {
      this.isPaused = !this.isPaused;
      if (!this.isPaused) {
        this.autoplay();
      } else {
        clearInterval(this.autoplayInterval);
      }
    },
  };
}
